import { createFileRoute } from "@tanstack/react-router"
import { FinanceOrdersPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/orders/"
)({
  component: () => (
    <AuthorizationGate resource={Resource.ORDER} action={Action.READ}>
      <FinanceOrdersPage />
    </AuthorizationGate>
  ),
})
